webpackJsonp([8],{

/***/ "./src/main/resources/static-site/js/portal-main.js":
/*!**********************************************************!*\
  !*** ./src/main/resources/static-site/js/portal-main.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var styles = __webpack_require__(/*! sass/portal/main.scss */ "./src/main/resources/static-site/sass/portal/main.scss");

'use strict';

undefined;
__webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(/*! modernizr */ "./src/main/resources/static-site/js/libs/vendor/modernizr/modernizr.js"), __webpack_require__(/*! moment */ "./src/main/resources/static-site/js/libs/vendor/moment/moment.js"), __webpack_require__(/*! underscore */ "./src/main/resources/static-site/js/libs/vendor/lodash/lodash.js"), __webpack_require__(/*! backbone */ "./src/main/resources/static-site/js/libs/vendor/backbone/backbone.js"), __webpack_require__(/*! closure-templates */ "./src/main/resources/static-site/js/libs/vendor/closure-templates/soyutils.js"), __webpack_require__(/*! jquery */ "./src/main/resources/static-site/js/libs/vendor/jquery/dist/jquery.js"), __webpack_require__(/*! FeatureConfig */ "./src/main/resources/static-site/featuresConfig.js"), __webpack_require__(/*! com/epam/heroes/core/core */ "./src/main/resources/static-site/js/com/epam/heroes/core/core.js"), __webpack_require__(/*! com/epam/heroes/core/config */ "./src/main/resources/static-site/js/com/epam/heroes/core/config.js"), __webpack_require__(/*! com/epam/heroes/core/util/GA */ "./src/main/resources/static-site/js/com/epam/heroes/core/util/GA.js"), __webpack_require__(/*! com/epam/heroes/core/util/HeroesCookies */ "./src/main/resources/static-site/js/com/epam/heroes/core/util/HeroesCookies.js"), __webpack_require__(/*! com/epam/heroes/core/browserValidator */ "./src/main/resources/static-site/js/com/epam/heroes/core/browserValidator.js"), __webpack_require__(/*! com/epam/heroes/portal/core/router/AnyMatchRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/core/router/AnyMatchRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/wall/router/WallRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/wall/router/WallRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/voting/router/VotingRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/voting/router/VotingRouter.js"), __webpack_require__(/*! com/epam/heroes/widget/givebadge/router/GiveBadgeRouter */ "./src/main/resources/static-site/js/com/epam/heroes/widget/givebadge/router/GiveBadgeRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/opportunities/router/ProfileOpportunitiesRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/opportunities/router/ProfileOpportunitiesRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/mypoints/router/ProfileMyPointsRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/mypoints/router/ProfileMyPointsRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/history/router/ProfileHistoryRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/history/router/ProfileHistoryRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/portfolio/router/ProfilePortfolioRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/portfolio/router/ProfilePortfolioRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/portfolio/router/PortfolioLevelsRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/portfolio/router/PortfolioLevelsRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/portfolio/router/PortfolioCollectionsRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/portfolio/router/PortfolioCollectionsRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/reviews/router/ProfileReviewsRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/reviews/router/ProfileReviewsRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/pending/router/ProfilePendingRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/pending/router/ProfilePendingRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/profile/approved/router/ApprovedBadgesRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/profile/approved/router/ApprovedBadgesRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/search/router/SearchRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/search/router/SearchRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/review/rating/router/RatingRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/review/rating/router/RatingRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/review/rating/beer/router/PageRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/review/rating/beer/router/PageRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/review/vote/router/ActiveReviewRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/review/vote/router/ActiveReviewRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/about/router/PageRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/about/router/PageRouter.js"), __webpack_require__(/*! com/epam/heroes/portal/core/router/V1RedirectRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/core/router/V1RedirectRouter.js"), __webpack_require__(/*! com/epam/heroes/core/view/BrowserAlertView */ "./src/main/resources/static-site/js/com/epam/heroes/core/view/BrowserAlertView.js"), __webpack_require__(/*! com/epam/heroes/portal/dashboards/router/DashboardsRouter */ "./src/main/resources/static-site/js/com/epam/heroes/portal/dashboards/router/DashboardsRouter.js"), __webpack_require__(/*! com/epam/closure/templates/functions */ "./src/main/resources/static-site/js/com/epam/closure/templates/functions.js"), __webpack_require__(/*! backbone.queryparams */ "./src/main/resources/static-site/js/libs/vendor/backbone-query-parameters/backbone.queryparams.js"), __webpack_require__(/*! jquery.sly */ "./src/main/resources/static-site/js/libs/vendor/sly/dist/sly.js"), __webpack_require__(/*! bootstrap/tooltip */ "./src/main/resources/static-site/js/libs/vendor/bootstrap-sass-official/assets/javascripts/bootstrap/tooltip.js")]; (function (modernizr, moment, _, Backbone, soy, $, featuresConfig, core, config, GA, HeroesCookies, BrowserValidator, AnyMatchRouter, WallRouter, VotingRouter, GiveBadgeRouter, ProfileOpportunitiesRouter, ProfileMyPointsRouter, ProfileHistoryRouter, ProfilePortfolio, PortfolioLevelsRouter, PortfolioCollectionsRouter, ProfileReviewsRouter, ProfilePendingRouter, ApprovedBadgesRouter, SearchRouter, RatingRouter, BeerRatingRouter, ActiveReviewRouter, AboutRouter, V1RedirectRouter, BrowserAlertView, DashboardsRouter) {

    addFavicons = function addFavicons(img) {
        var head = document.querySelector('head');
        img.map(function (href) {
            var favicon = document.createElement('link');
            favicon.setAttribute('rel', href.indexOf('.ico') !== -1 ? 'shortcut icon' : 'icon');
            href.indexOf('.ico') !== -1 && favicon.setAttribute('id', 'favicon');
            href.indexOf('.png') !== -1 && favicon.setAttribute('sizes', href.indexOf('16') !== -1 ? '16x16' : '32x32');
            head.appendChild(favicon);

            href.indexOf('.png') !== -1 ? favicon.setAttribute('type', 'image/png') : favicon.setAttribute('type', 'image/x-icon');
            favicon.setAttribute('href', href);
        });
    };

    var VERSION = new Date().getTime();

    if (featuresConfig.featurePetrofacUiStylesEnabled) {
        __webpack_require__(/*! ../sass/petrofac-portal/main.scss */ "./src/main/resources/static-site/sass/petrofac-portal/main.scss");

        addFavicons([config.staticSiteUrl + ('/images/portal/favicons/petrofac_favicon.ico?v=' + VERSION), config.staticSiteUrl + ('/images/portal/favicons/petrofac_favicon16.png?v=' + VERSION), config.staticSiteUrl + ('/images/portal/favicons/petrofac_favicon32.png?v=' + VERSION)]);
    } else {
        addFavicons([config.staticSiteUrl + ('/images/portal/favicons/favicon.ico?v=' + VERSION), config.staticSiteUrl + ('/images/portal/favicons/favicon16.png?v=' + VERSION), config.staticSiteUrl + ('/images/portal/favicons/favicon32.png?v=' + VERSION)]);
    }

    /**
     * Test browser for preserve-3d support.
     */
    Modernizr.addTest('preserve3d', function () {
        var prop = Modernizr.testAllProps('transformStyle', 'pfx');
        var elem = document.createElement('a');
        elem.style[prop] = 'preserve-3d';
        var test = elem.style[prop] === 'preserve-3d';
        elem = null;
        return test;
    });

    // Change language to English globally
    moment.locale('en', {
        calendar: {
            sameDay: '[Today,] H:mm',
            lastDay: '[Yesterday,] H:mm',
            nextDay: '[Tomorrow,] H:mm',
            lastWeek: 'D MMM, H:mm',
            nextWeek: 'D MMM, H:mm',
            sameElse: 'D MMM YY, H:mm'
        },
        relativeTime: {
            future: '%s left',
            past: '%s ago',
            s: 'Seconds',
            m: 'A minute',
            mm: '%d minutes',
            h: 'An hour',
            hh: '%d hours',
            d: 'A day',
            dd: '%d days',
            M: 'A month',
            MM: '%d months',
            y: 'A year',
            yy: '%d years'
        }
    });

    /*
     * Set up custom headers that will be sent with all ajax requests.
     * Generate pseudorandom value (fkey) that will be sent
     * both as cookie and HTTP header in order to prevent CSRF attacks.
     */
    $.ajaxPrefilter(function (options, originalOptions, xhr) {
        var url = document.URL,
            step = null;
        if (/^.*\/vote\/\d+\/\d+$/.test(url)) {
            step = 'vote';
        } else if (/^.*\/rating\/\d+\/\d+$/.test(url)) {
            step = 'rating';
        }
        xhr.setRequestHeader('Heroes-API-Client', 'portal');
        if (step) {
            xhr.setRequestHeader('Heroes-API-Client-Step', step);
        }
        if (options.type !== 'GET') {
            var fkey = HeroesCookies.get('fkey');
            xhr.setRequestHeader('Heroes-API-Client-Fkey', fkey);
        }
    });
    var fkey = core.Application.uuid();
    HeroesCookies.set('fkey', fkey, { path: '/' });

    core.Application.setUser(new core.UserModel());

    //Check browser
    if (BrowserValidator.isOldBrowserVersion()) {
        var browserAlertView = new BrowserAlertView({
            name: 'BrowserAlertView',
            el: 'body',
            browsers: BrowserValidator.browsers
        });
        core.Application.setView(browserAlertView);
        browserAlertView.render();
    } else {
        // Create routers before history start
        new AnyMatchRouter(); // Make sure that AnyMatchRouter is the first one to be initialized
        new ProfilePortfolio();
        new PortfolioLevelsRouter();
        new PortfolioCollectionsRouter();
        new ProfileOpportunitiesRouter();
        new ProfileMyPointsRouter();
        new ProfileHistoryRouter();
        new ProfileReviewsRouter();
        new ProfilePendingRouter();
        new ApprovedBadgesRouter();
        new WallRouter();
        new VotingRouter();
        new GiveBadgeRouter();
        new SearchRouter();
        new RatingRouter();
        new BeerRatingRouter();
        new ActiveReviewRouter();
        if (featuresConfig.featureAboutUsEnabled && featuresConfig.featureHelpEnabled) {
            new AboutRouter();
        }
        new V1RedirectRouter();
        new DashboardsRouter();
    }

    Backbone.history.start({
        pushState: true,
        root: config.portalUrl
    });

    if (!featuresConfig.featurePetrofacUiStylesEnabled) {
        GA && GA.create(); // Create Google Analytics tracker
    }
}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);


/***/ }),

/***/ "./src/main/resources/static-site/sass/portal/main.scss":
/*!**************************************************************!*\
  !*** ./src/main/resources/static-site/sass/portal/main.scss ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/*!*******************************************************************************!*\
  !*** multi babel-polyfill ./src/main/resources/static-site/js/portal-main.js ***!
  \*******************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! babel-polyfill */"./node_modules/babel-polyfill/lib/index.js");
module.exports = __webpack_require__(/*! /builds/epm-hero/petrofc/heroes-app/src/main/resources/static-site/js/portal-main.js */"./src/main/resources/static-site/js/portal-main.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// static-site/js/portal.fb092fd9.js